// extracted by mini-css-extract-plugin
export default {"imageContainer":"MyProfilePhotos_imageContainer__SfZEB","image":"MyProfilePhotos_image__Xtijo"};